import { activeIssueTypes, inactiveIssueTypes }
  from "../../helpers/selectOptions/implementer/submission"

export const useActiveIssueTypes = issueType => {

  const activeIssueTypesForCompare = activeIssueTypes.map(({ value }) => value) || []

  if (issueType) {
    return activeIssueTypesForCompare?.some(e => e === issueType)
      ? activeIssueTypes : inactiveIssueTypes
  }
  return activeIssueTypes
}